import Title from "./components/Title/Title";
import Paragraph from "./components/Paragraph/Paragraph";
import Button from "./components/Button/Button";
import OptionsItem from "./components/OptionsItem/OptionsItem";
import React, { useEffect, useState } from "react";
import imageStartScreen from "./assets/images/00.png";
import imageResult from "./assets/images/9.png";
import styles from "./App.module.scss";
import questions from "./state/questions";
import classNames from "classnames";
import Result from "./components/Result/Result";

function App() {
  const [currentQuestion, setCurrentQuestion] = useState(0); // считаем номер вопроса
  const [stateFlow, setStateFlow] = useState("Start"); // состояние флоу: стартовый экран / вопросы / результат
  const [option, setOption] = useState(false); // выбран ли ответ
  const [resultState, setResultState] = useState(""); // выводить ли результат
  const [resultCount, setResultCount] = useState(0); // счетчик правильных вопросов
  const phone = document.getElementById("phone"); // находим область телефона на десктопе

  // console.log(resultCount); // тестирование логики

  // прокрутка вниз при нажатии на ответ
  const optionActiveHandler = (option) => {
    setOption(option);

    setTimeout(() => {
      window.scrollTo({ top: 1000, behavior: "smooth" });
      phone.scrollTo({ top: 1000, behavior: "smooth" });
    }, "50");
  };

  const resultCountLogic = (result) => {
    setResultCount(resultCount + result);
  };

  // поднимаемся наверх после перехода на страницу
  const scrollReset = (event) => {
    window.scrollTo(0, 0);
    phone.scrollTo(0, 0);
  };

  // Скролл наверх при нажатии старт квиз
  const startFlow = () => {
    setStateFlow("Flow");
    window.scrollTo(0, 0);
  };

  // логика флоу
  const handlerNext = () => {
    if (currentQuestion === 4) {
      setStateFlow("End");

      setResultState(() => {
        if (resultCount <= 1) {
          return (
            <Result
              title="ขอบคุณนะ! ได้เวลาสตาร์ทเครื่องสร้างรายได้กันต่อแล้ว"
              text={
                "เพิ่มรายได้ให้ปังขึ้นได้ง่าย ๆ แค่เลือกซื้อแพ็กเกจคอมมิชชันสุดคุ้ม ยิ่งซื้อกะ ยิ่งวิ่งรับงานได้คุ้มกว่าเดิม!"
              }
              imageSrc={imageResult}
              posterContainer={styles.posterContainer}
              optionsContainer={styles.optionsContainer}
              handlerBack={handlerBack}
            />
          );
        }

        if (resultCount >= 2 && resultCount <= 3) {
          return (
            <Result
              title="ขอบคุณนะ! ได้เวลาสตาร์ทเครื่องสร้างรายได้กันต่อแล้ว"
              text={
                "เพิ่มรายได้ให้ปังขึ้นได้ง่าย ๆ แค่เลือกซื้อแพ็กเกจคอมมิชชันสุดคุ้ม ยิ่งซื้อกะ ยิ่งวิ่งรับงานได้คุ้มกว่าเดิม!"
              }
              imageSrc={imageResult}
              posterContainer={styles.posterContainer}
              optionsContainer={styles.optionsContainer}
              handlerBack={handlerBack}
            />
          );
        }

        if (resultCount >= 3 && resultCount <= 4) {
          return (
            <Result
              title="ขอบคุณนะ! ได้เวลาสตาร์ทเครื่องสร้างรายได้กันต่อแล้ว"
              text={
                "เพิ่มรายได้ให้ปังขึ้นได้ง่าย ๆ แค่เลือกซื้อแพ็กเกจคอมมิชชันสุดคุ้ม ยิ่งซื้อกะ ยิ่งวิ่งรับงานได้คุ้มกว่าเดิม!"
              }
              imageSrc={imageResult}
              posterContainer={styles.posterContainer}
              optionsContainer={styles.optionsContainer}
              handlerBack={handlerBack}
            />
          );
        }
      });

      // сбрасываем  скролл для результата
      scrollReset();
    } else {
      setOption(false);
      setCurrentQuestion(currentQuestion + 1);

      // прокрутка вверх после нажатия на ответ
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        phone.scrollTo({ top: 0, behavior: "smooth" });
      }, "50");
    }
  };

  // возвращение в начало
  const handlerBack = () => {
    setOption(false);
    setStateFlow("Start");
    setCurrentQuestion(0);
    setResultCount(0);
  };

  // считаем цифры прокрутки и верешаем options::after
  const [offset, setOffset] = useState(false);

  useEffect(() => {
    const handleScroll = (event) => {
      if (window.scrollY > 50) {
        setOffset(true);
      } else {
        setOffset(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className={styles.wrapperContainer}>
      <div className={styles.wrapper}>
        <div className={styles.phone} id="phone">
          {stateFlow === "Start" ? (
            <>
              <div className={styles.posterContainer}>
                <img src={imageStartScreen} className={styles.image} alt="" />
              </div>
              <div
                className={classNames({
                  [styles.optionsContainer]: true,
                  [styles.onScrollOption]: offset,
                })}
              >
                <div className={styles.bgWhite}>
                  <div className={styles.contentWrapper}>
                    <Title value="ช่วยมือใหม่ก้าวสู่มือโปร" />
                    <Paragraph value="สมชายเพิ่งเริ่มขับกับ Maxim และต้องการคำแนะนำจากมือโปรแบบคุณ" />
                    <Paragraph value="ช่วยให้เขาสร้างรายได้จากออเดอร์แรก พร้อมเรียนรู้วิธีเพิ่มรายได้จากการขับรถให้คุ้มค่ามากยิ่งขึ้น" />
                  </div>
                  <Button
                    value="ถัดไป"
                    onClick={() => startFlow()}
                    id="start"
                  />
                </div>
              </div>
            </>
          ) : stateFlow === "Flow" ? (
            <>
              <div className={styles.posterContainer}>
                <img
                  src={questions[currentQuestion].image}
                  className={styles.image}
                  alt={questions[currentQuestion].image}
                />
              </div>
              <div
                className={classNames({
                  [styles.optionsContainer]: true,
                  [styles.onScrollOption]: offset,
                })}
              >
                <div className={styles.bgWhite}>
                  <div className={styles.header}>
                    <Title value={questions[currentQuestion].questionText} />
                  </div>

                  <div>
                    <div className={styles.headerDesc}>
                      <Title value={questions[currentQuestion].questionDesc} />
                    </div>
                  </div>

                  <div className={styles.optionsWrapper}>
                    {questions[currentQuestion].answerOptions.map((item) => (
                      <OptionsItem
                        key={item.answerText}
                        title={item.answerText}
                        resultText={item.answerResult}
                        onClick={optionActiveHandler}
                        disabled={option}
                        result={item.result}
                        resultCountLogic={resultCountLogic}
                      />
                    ))}
                  </div>

                  <Button
                    value="ถัดไป"
                    onClick={() => handlerNext()}
                    disabled={!option}
                    id={"btn" + (currentQuestion + 1)}
                  />
                </div>
              </div>
            </>
          ) : (
            <>{resultState}</>
          )}
        </div>
      </div>
    </div>
  );
}

export default App;
